export default __webpack_public_path__ + "static/media/img_22.5da72f4b.JPG";